import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;

export const RadioWrapper = styled.div`
  width: ${rem(170)};
`;

export const HorizontalLine = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  padding-bottom: ${rem(18)};
`;

export const SubTitle = styled.div`
  font-family: 'Open Sans';
  justify-content: space-between;
  display: flex;
  font-weight: 400;
  font-size: ${rem(13)};
  margin: ${rem(16)};
  font-style: italic;
  margin-right: 0px;
`;

export const SubTitleWrapper = styled.div`
  font-family: 'Open Sans';
  justify-content: space-between;
  display: flex;
  font-weight: 400;
  font-size: ${rem(13)};
  margin: ${rem(16)};
  font-style: italic;
  margin-right: 0px;
`;
